import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export const DRIVE_KEYS_PAGE_SIZE = 100;
/**
 * Query drive files
 */
export default async function getDriveFiles(query: { entry_ids: string[] }) {
  const res = await fetchOrchidAPI("/api/drive_data/snapshot/storage", {
    credentials: "include",
    mode: "cors",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(query),
  });

  if (!res.ok) {
    throw new Error(
      `failed to get file encryption keys: ${getErrorDetail(await res.text())}`,
    );
  }

  const data: {
    files: OrchidDriveFileNotify[];
    directories: OrchidDriveDirectoryNotify[];
    failed_entries: {
      entry_id: string;
      error: string;
    }[];
  } = await res.json();

  if (data.failed_entries.length > 0) {
    console.error(
      "Failed to retrieve some of the drive entry metadata: ",
      data.failed_entries,
    );
    throw new Error("failed to retrieve some of the drive entry metadata");
  }

  return data;
}
